import { render, staticRenderFns } from "./SubMenu.vue?vue&type=template&id=fe8aa650&scoped=true&"
import script from "./SubMenu.vue?vue&type=script&lang=js&"
export * from "./SubMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe8aa650",
  null
  
)

export default component.exports